module.exports = __webpack_public_path__ + "static/media/quiz8.d53f80bd.png";